// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CEvv8","col":"styles_col__wvqST"};